import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Save, Tag } from 'lucide-react';

const getCategoryShortName = (key) => key.replace('cat_', 'Cat. ').toUpperCase().replace('CAT. ', 'Cat. ');

export function AdminCategoriesTab({ categories, onUpdateLabel, onSave, saving }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="font-heading text-2xl flex items-center gap-2"><Tag className="w-6 h-6" /> Gestione Categorie Manifestazioni</CardTitle>
        <p className="text-sm text-muted-foreground">Modifica il testo delle categorie. Le categorie senza testo risulteranno inattive.</p>
      </CardHeader>
      <CardContent className="space-y-4">
        {categories.map((cat, index) => (
          <div key={cat.key} className="space-y-1" data-testid={`category-row-${cat.key}`}>
            <div className="flex items-center gap-2">
              <Label className="font-semibold text-sm min-w-[50px]">{getCategoryShortName(cat.key)}</Label>
              {cat.active ? <Badge variant="default" className="text-xs">Attiva</Badge> : <Badge variant="secondary" className="text-xs">Vuota</Badge>}
            </div>
            <Textarea
              value={cat.label}
              onChange={(e) => onUpdateLabel(index, e.target.value)}
              placeholder={`Inserisci descrizione per ${getCategoryShortName(cat.key)}...`}
              rows={2} className="text-sm resize-none"
              data-testid={`category-input-${cat.key}`}
            />
          </div>
        ))}
        <Button onClick={onSave} disabled={saving} className="btn-scale mt-6" data-testid="save-categories-button">
          <Save className="w-4 h-4 mr-2" />{saving ? 'Salvataggio...' : 'Salva Categorie'}
        </Button>
        <div className="p-4 rounded-lg bg-muted mt-4">
          <p className="text-sm text-muted-foreground"><strong>Nota:</strong> Le categorie vuote non vengono mostrate. Puoi aggiungerne di nuove compilando Cat. H - Cat. L.</p>
        </div>
      </CardContent>
    </Card>
  );
}
